// These properties control the timing offsets and maximums for when we poll for updates on orders that are awaiting pricing loads

export const INITIAL_PRICE_N_AVAILABILITY_POLLING_TIME = 3000;
export const SUBSEQUENT_PRICE_N_AVAILABILITY_POLLING_TIME = 5000; // 5s between checks after that seems fair
export const MAX_POLLING_TIME = 180000; // Don't let polling go past 3 minutes
